import { render, staticRenderFns } from "./source-action.vue?vue&type=template&id=18b16720&"
import script from "./source-action.vue?vue&type=script&lang=js&"
export * from "./source-action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports